<template>
  <div class="graph-dashboard">
    <v-container fluid>
      <v-row align="center" justify="center" v-if="layoutInformation.downGraph">
        <v-col>
          <v-card ma-5 height="232px" v-if="siteStatus.length > 0">
            <v-card-title>
              {{ siteStatus[0].name }}
              <v-spacer/>
              <span class="text-h4">{{ siteStatus[0].temperature }}ºC&nbsp;&nbsp;&nbsp;</span>
            </v-card-title>
            <v-card-text class="big-card-text">
              <v-row>
                <v-col>
                  <v-icon class="mr-2" color="green" v-if="siteStatus[0].motorRun">fas fa-circle-notch fa-spin</v-icon>
                  <v-icon class="mr-2" color="red" v-else>block</v-icon>
                  모터 {{ minutesToText(siteStatus[0].motorStatusContinuesMinutes)}} {{ siteStatus[0].motorRun? '동작중' : '정지중'}}<br/>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;누적 금일 {{ minutesToTextForAccumulation(siteStatus[0].motorRunTodayMinutes)}}<br/>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;전체 {{ minutesToText(siteStatus[0].totalMotorRunMinutes)}} 동작
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <div align="center">
                    <div v-if="siteStatus[0].hasNoError">
                      <v-chip class="ma-1 mt-n3" large color="green" text-color="white">
                        <v-icon>check</v-icon>&nbsp;정상&nbsp;
                      </v-chip>
                    </div>
                    <div v-else>
                      <v-chip class="ma-1 mt-n3" large color="red" text-color="white">
                        <v-icon>error</v-icon>&nbsp;에러&nbsp;
                      </v-chip>
                    </div>

                    <!-- disabled? -->
                    <!--
                    <v-chip class="ma-1" large color="red" text-color="white" v-if="siteStatus[0].undergroundWaterError">FLOAT</v-chip>
                    <v-chip class="ma-1" large color="red" text-color="white" v-if="siteStatus[0].overloadError">EOCR</v-chip>
                    <v-chip class="ma-1" large color="red" text-color="white" v-if="siteStatus[0].electricWaveError">전파 이상</v-chip>
                    -->
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card ma-5 v-else>
            <v-card-title></v-card-title>
            <v-card-text>데이터 없음</v-card-text>
          </v-card>
        </v-col>

        <v-col>
          <v-card ma-5>
            <v-card-title>현재 탱크 수위</v-card-title>
            <v-card-text>
              <div class="chartCurrentTankWaterLevel"></div>
            </v-card-text>
          </v-card>
        </v-col>

        <!--disabled-->
        <!--<v-col>
          <v-card ma-5>
            <v-card-title>현재 약품 수위</v-card-title>
            <v-card-text>
              <div class="chartCurrentChemical"></div>
            </v-card-text>
          </v-card>
        </v-col>-->
      </v-row>

      <v-row align="center" justify="center" v-if="layoutInformation.downGraph">
        <!--disabled-->
        <!--<v-col>
          <v-card ma-5>
            <v-card-title>
              모터 작동 추이
              &lt;!&ndash;<v-spacer/>&ndash;&gt;&lt;!&ndash; TODO 빅차트도 하고 싶다 &ndash;&gt;
              &lt;!&ndash;<v-icon @click="openBigChart('모터 작동 추이', 'chartMotor')">open_in_new</v-icon>&ndash;&gt;
            </v-card-title>
            <v-card-text>
              <div class="chartMotor"></div>
            </v-card-text>
          </v-card>
        </v-col>-->

        <v-col>
          <v-card ma-5>
            <v-card-title>물탱크 수위 추이</v-card-title>
            <v-card-text>
              <div class="chartTankWaterLevel"></div>
            </v-card-text>
          </v-card>
        </v-col>

        <!--disabled-->
        <!--<v-col>
          <v-card ma-5>
            <v-card-title>약품 수위 추이</v-card-title>
            <v-card-text>
              <div class="chartChemical"></div>
            </v-card-text>
          </v-card>
        </v-col>-->
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import moment from 'moment'

  export default {
    name: 'graphDashboard',
    props: {
      siteStatus: {
        type: Array,
        required: true
      },
      dateRange: {
        type: Object,
        required: true
      },
      selectedSiteStatus: {
        type: Object,
        required: true
      },
      layoutInformation: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        //bigChartDialog: false,
        // bigChart: {
        //   chartName: '',
        //   chartId: ''
        // },
        notEmptyValidation: [
          value => !!value || '필수 값입니다'
        ],
      }
    },
    methods: {
      minutesToText(minutes) {
        if (minutes < 60) {
          return `${minutes} 분째`;
        }

        const hours = parseInt(minutes / 60);
        const remainMinutes = minutes % 60;

        if (hours < 24) {
          if (remainMinutes === 0) {
            return `${hours} 시간째`;
          }
          return `${hours} 시간 ${remainMinutes} 분째`;
        }

        const days = parseInt(hours / 24);
        const remainHours = hours % 24;
        if (days < 365) {
          if (remainHours === 0) {
            return `${days} 일 이상`;
          } else {
            return `${days} 일 ${remainHours} 시간 이상`;
          }
        }

        const years = parseInt(days / 365);
        const remainDays = days % 365;
        if (remainDays === 0) {
          return `${years} 년 이상`;
        }

        const months = parseInt(remainDays / 30);
        if (months === 0) {
          return `${years} 년 이상`;
        } else {
          return `${years} 년 ${months} 개월 이상`;
        }
      },
      minutesToTextForAccumulation(minutes) {
        if (minutes < 60) {
          return `${minutes} 분`;
        }

        const hours = parseInt(minutes / 60);
        const remainMinutes = minutes % 60;

        if (hours < 24) {
          if (remainMinutes === 0) {
            return `${hours} 시간`;
          }
          return `${hours} 시간 ${remainMinutes} 분`;
        }

        return '24 시간'
      },
      printDebugLog(target) {
        console.dir(target);
      },
      popupAlert(message, color) {
        this.$bus.$emit('popupAlert', {message: message, color: color});
      },
      refreshGraphs() {
        this.$bus.$emit('refreshGraphs');
      }
    }
  }
</script>

<style>
  @import url('../../../node_modules/billboard.js/dist/billboard.css');

  .big-card-text {
    font-size: 20px;
  }
</style>